const currencyFormat = (numString) => {
    numString = numString.toString().replace(/\./g, "")
    numString = numString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return numString
}

export {currencyFormat};